/* mp-club.js — Naso Club: filtri premi, dialogo di riscatto, scheda header su touch.
   Nessuna dipendenza. Il riscatto vero passa dall'app proxy (/apps/naso/redeem) quando il backend è collegato;
   finché non lo è, il dialogo mostra i numeri e chiude senza scrivere nulla. */
(function () {
  'use strict';
  var PROXY = '/apps/naso';
  var connected = !!(window.mpNasoClub && window.mpNasoClub.proxy);

  // Filtri del catalogo premi
  var filters = document.querySelector('[data-mp-nc-filters]');
  var grid = document.querySelector('[data-mp-nc-rewards]');
  if (filters && grid) {
    filters.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-f]');
      if (!b) return;
      filters.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var f = b.getAttribute('data-f');
      grid.querySelectorAll('.mp-nc-reward').forEach(function (card) {
        var show = f === 'all' ? true : card.getAttribute('data-kind') === f;
        card.hidden = !show;
      });
    });
  }

  // Dialogo di riscatto
  var dlg = document.getElementById('mp-nc-redeem');
  if (dlg) {
    var fmt = function (n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
    var avail = parseInt((dlg.querySelector('.mp-nc-line b') || {}).textContent || '0', 10) || 0;
    var availRaw = parseInt(String((dlg.querySelector('.mp-nc-line b') || {}).textContent || '0').replace(/\./g, ''), 10) || 0;
    var current = null;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mp-nc-redeem]');
      if (!b) return;
      current = { handle: b.getAttribute('data-mp-nc-redeem'), title: b.getAttribute('data-title'), points: parseInt(b.getAttribute('data-points'), 10) };
      dlg.querySelector('[data-r-title]').textContent = current.title;
      dlg.querySelector('[data-r-points]').textContent = '− ' + fmt(current.points);
      dlg.querySelector('[data-r-after]').textContent = fmt(Math.max(0, availRaw - current.points));
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    });
    dlg.addEventListener('close', function () {
      if (dlg.returnValue !== 'confirm' || !current) return;
      if (!connected) {
        var n = document.createElement('p');
        n.className = 'mp-nc-small';
        n.style.cssText = 'color:var(--nc-gold);margin:12px 0 0';
        n.textContent = 'Il riscatto sarà attivo al lancio del Club: il tuo premio "' + current.title + '" è stato annotato.';
        var host = document.getElementById('mp-nc-miei');
        if (host && host.parentNode) host.parentNode.insertBefore(n, host.nextSibling);
        return;
      }
      fetch(PROXY + '/redeem', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ reward: current.handle }) })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.ok) window.location.reload(); })
        .catch(function () {});
    });
  }

  // Profilo olfattivo: validazione; senza backend annota sul dispositivo e lo dice, con il proxy invia
  var pf = document.querySelector('[data-mp-nc-profile]');
  if (pf) {
    var msg = pf.querySelector('[data-mp-nc-profile-msg]');
    pf.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(pf);
      var data = {
        likes: fd.getAll('likes'), dislikes: fd.getAll('dislikes'),
        materials: String(fd.get('materials') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 3),
        intensity: fd.get('intensity'), season: fd.get('season'), occasion: fd.get('occasion')
      };
      if (!data.likes.length) { msg.textContent = 'Scegli almeno una famiglia che ami.'; return; }
      var overlap = data.likes.filter(function (x) { return data.dislikes.indexOf(x) > -1; });
      if (overlap.length) { msg.textContent = 'Una famiglia non può essere insieme amata ed evitata: ' + overlap.join(', ') + '.'; return; }
      if (!connected) {
        try { localStorage.setItem('mpnc_profile', JSON.stringify(data)); } catch (err) {}
        msg.textContent = 'Profilo annotato. Il salvataggio sul tuo account e i 200 punti arrivano con il lancio del Club.';
        return;
      }
      fetch(PROXY + '/profile', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) })
        .then(function (r) { return r.json(); })
        .then(function (j) { msg.textContent = j && j.ok ? 'Profilo salvato.' : 'Non siamo riusciti a salvare: riprova tra poco.'; })
        .catch(function () { msg.textContent = 'Non siamo riusciti a salvare: riprova tra poco.'; });
    });
  }

  // Carrello: il drawer del tema ri-renderizza solo le righe (api-cart-items); le parti del Club si aggiornano da sole.
  // 23-09-2026: più parti (data-slot: goal = riga della spedizione, club, upsell), ognuna presa dalla sua gemella nella
  // sezione appena scaricata; si tiene ?view= così le anteprime con i dati di esempio restano coerenti.
  var slots = document.querySelectorAll('[data-mp-nc-cart-slot]');
  if (slots.length) {
    var sectionId = slots[0].getAttribute('data-mp-nc-cart-slot') || 'cart-drawer';
    var cartTimer = null;
    var refreshCartBlock = function () {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () {
        var view = new URLSearchParams(window.location.search).get('view');
        var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId) + (view ? '&view=' + encodeURIComponent(view) : '');
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            slots.forEach(function (s) {
              var name = s.getAttribute('data-slot');
              var fresh = name ? doc.querySelector('[data-mp-nc-cart-slot][data-slot="' + name + '"]') : doc.querySelector('[data-mp-nc-cart-slot]');
              if (fresh) s.innerHTML = fresh.innerHTML;
            });
            document.dispatchEvent(new CustomEvent('cdn:cart:slots'));
          }).catch(function () {});
      }, 250);
    };
    ['theme:cart:change', 'theme:cart:add', 'theme:cart:update', 'theme:cart:refresh', 'theme:cart-drawer:open'].forEach(function (ev) { document.addEventListener(ev, refreshCartBlock); });
  }

  // Header: su touch la scheda si apre al tocco (details nativo); chiudi con Esc e con tocco fuori.
  // Deep link #nc-card (email, lettera): apre la scheda del grado all'arrivo.
  document.querySelectorAll('[data-mp-nc-hd]').forEach(function (d) {
    if (window.location.hash === '#nc-card') d.open = true;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) d.open = false; });
    document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
  });
})();
